import {
  BigDotIcon,
  Box,
  CloseIcon,
  GKTextField,
  Grid2,
  IconButton,
  InfoItalicIcon,
  Show,
  Typography,
} from "components";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { WebsiteDetails } from "./types";
import { useState } from "react";

const PerformanceMetricsForm = () => {
  const form = useFormContext<WebsiteDetails>();

  const [showDescription, setShowDescription] = useState(() => {
    const saved = localStorage.getItem("showDescription");
    return saved ? JSON.parse(saved) : false;
  });

  const { fields } = useFieldArray({
    control: form.control,
    name: "websiteSection.performanceMetrices.performanceMetrics",
  });

  return (
    <Grid2 container spacing={3}>
      <Grid2 container size={12} spacing={1}>
        {fields.map((field, index) => (
          <Grid2 container size={12} spacing={1} key={field.id}>
            <Grid2 size={6}>
              <Controller
                name={`websiteSection.performanceMetrices.performanceMetrics.${index}.text`}
                control={form.control}
                render={({ field }) => (
                  <GKTextField {...field} placeholder="Enter Key" />
                )}
              />
            </Grid2>

            <Grid2 size={6}>
              <Controller
                name={`websiteSection.performanceMetrices.performanceMetrics.${index}.value`}
                control={form.control}
                render={({ field }) => (
                  <GKTextField {...field} placeholder="Enter Value" />
                )}
              />
            </Grid2>
          </Grid2>
        ))}
      </Grid2>

      <Show.When isTrue={!showDescription}>
        <Grid2
          container
          size={12}
          p={1.5}
          bgcolor={"var(--yellow-100)"}
          borderRadius={2}
        >
          <Grid2 size={1}>
            <InfoItalicIcon />
          </Grid2>
          <Grid2 container size={11} spacing={2}>
            <Grid2 size={11}>
              <Typography
                fontSize={12}
                fontWeight={500}
                color="var(--grey-900)"
              >
                Add performance metrics that highlight your credibility and
                client success. Choose numbers like clients served, or years of
                experience to build trust.
              </Typography>
            </Grid2>
            <Grid2
              size={1}
              display={"flex"}
              alignItems={"flex-start"}
              justifyContent={"flex-end"}
            >
              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                  localStorage.setItem("showDescription", "true");
                  setShowDescription(true);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid2>
            <Grid2 size={12}>
              <Typography
                fontSize={12}
                fontWeight={700}
                color="var(--grey-900)"
              >
                Examples of Metrics You Can Add:
              </Typography>
              <Grid2 size={12} container spacing={0.5}>
                <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "145px",
                    }}
                  >
                    <BigDotIcon width={20} height={20} />
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      color="var(--grey-900)"
                    >
                      Examples of Metrics:
                    </Typography>
                  </Box>
                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color="var(--grey-900)"
                  >
                    250+ Happy Clients
                  </Typography>
                </Grid2>
                <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "145px",
                    }}
                  >
                    <BigDotIcon width={20} height={20} />
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      color="var(--grey-900)"
                    >
                      Years of Experience:
                    </Typography>
                  </Box>
                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color="var(--grey-900)"
                  >
                    Average 12% Growth
                  </Typography>
                </Grid2>
                <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "145px",
                    }}
                  >
                    <BigDotIcon width={20} height={20} />
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      color="var(--grey-900)"
                    >
                      Industry Recognition:
                    </Typography>
                  </Box>
                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color="var(--grey-900)"
                  >
                    SEBI Registered Since 2012
                  </Typography>
                </Grid2>
                <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "145px",
                    }}
                  >
                    <BigDotIcon width={20} height={20} />
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      color="var(--grey-900)"
                    >
                      Team Strength:
                    </Typography>
                  </Box>
                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color="var(--grey-900)"
                  >
                    10+ Experts Onboard
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
            <Grid2 size={12} display={"flex"} gap={1}>
              <Typography
                fontSize={12}
                fontWeight={700}
                color="var(--grey-900)"
              >
                Tip:
              </Typography>
              <Typography
                fontSize={12}
                fontWeight={400}
                color="var(--grey-900)"
              >
                Always keep the data accurate and updated to maintain client
                confidence.
              </Typography>
            </Grid2>
          </Grid2>
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default PerformanceMetricsForm;
